import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface RegisterAccountOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  UrlRedirect?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRegisterAccountOutput = (output: any): output is RegisterAccountOutput => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const ActionRequired = 'ActionRequired'
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const UrlRedirect = 'UrlRedirect'

  return isBaseOutput(output) && has(output, ActionRequired) && has(output, UrlRedirect)
}
